import axios from 'axios';

const base = `${process?.env?.REACT_APP_CHATHUB_SERVER}/api/chat`;

export const getUserCredentials = async () => {
    const idProvider = prefixDomainAndProtocol(process?.env?.REACT_APP_BASE_URL);
    const response = await axios.post(
        `${base}/join`,
        {
            idProvider: idProvider,
            service: 'matrix',
        },
        {
            withCredentials: false,
        }
    );

    //Update sessionStorage with refresh token
    sessionStorage.setItem('chathubAuth', JSON.stringify(response?.data?.chat));

    return response;
};

export function prefixDomainAndProtocol(path) {
    return (path || '').toString()[0] === "/"
        ? `${window.location.protocol}//${window.location.host}${path}`
        : path;
}